import { Component, OnInit } from '@angular/core';
import {Notizia} from "../../models/notizia";
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {NewsService} from "../../services/news/news.service";
import {CommonService} from "../../services/common/common.service";
import {Title} from "@angular/platform-browser";
import {AudioricetteService} from "../../services/audioricette/audioricette.service";
import {Audioricetta} from "../../models/audioricetta";

@Component({
  selector: 'app-audio-ricetta-detail',
  templateUrl: './audio-ricetta-detail.component.html',
  styleUrls: ['./audio-ricetta-detail.component.scss']
})
export class AudioRicettaDetailComponent implements OnInit {

  audioricetta!: Audioricetta;


  constructor(
    private route: ActivatedRoute,
    private audioRicetteService: AudioricetteService,
    private router: Router,
    private commonService: CommonService,
    private title:Title,
  ) {
  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      let id = params.get('id');
      console.log('params', params);

      if (id) {
        this.audioRicetteService.audioricette_single(id).then(risp => {

          this.audioricetta = risp;
          //imposto opengraph

          this.title.setTitle( this.audioricetta.titolo );


        }, errore => {
          console.log(errore);
        });
      } else {
        //non ho il parametro id, torno indietro a news list
        this.router.navigate(['/audio-ricette']);
      }
    })


  }


}
